import React from "react";
import { ITextInputErrorWarning } from "../../../store/@types/misc";

type checkBoxProps = {
  name: string;
  value: boolean;
  label: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  status?: ITextInputErrorWarning;
};

const CheckBox: React.FC<checkBoxProps> = ({
  name,
  value = false,
  label,
  onChange,
  status,
}) => {
  const color = status ? "text-[red]" : "text-gray-900";
  return (
    <div className="flex items-center">
      <input
        id={name}
        name={name}
        onChange={onChange}
        type="checkbox"
        checked={value}
        className="h-4 w-4"
      />
      <label
        htmlFor={name}
        className={`ml-2 block text-[12px] md:text-sm ${color}`}
        dangerouslySetInnerHTML={{ __html: label }}
      ></label>
    </div>
  );
};

export default CheckBox;
